export default {
  app: {
    privacy: {
      policy: 'Política de privacitat',
      expansive: "En utilitzar Expansive, acceptes l'{action} d'Expansive",
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessió caducada',
    sessionExpiredDescription:
      'La teva sessió ha caducat. Si us plau, inicia sessió de nou per continuar utilitzant l’aplicació.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Tria l’idioma',
      chooseLanguageDescription:
        'Tria el teu idioma preferit per a l’aplicació. Això canviarà l’idioma de la interfície i el contingut.',
    },
    userSelection: {
      cancel: 'Cancel·la',
      createNewUser: 'El seu nom no apareix a la llista',
      newUser: 'Nou usuari',
      selectAnExistingUser: 'Selecciona un usuari existent',
      selectUserHint: 'Selecciona un usuari existent o crea’n un de nou per continuar.',
      startTypingToSearch: 'Comença a escriure...',
    },
    verification: {
      codeVerification: {
        continue: 'Continua',
        header: 'Introdueix el codi d’accés al lloc',
        invalidCode: 'Codi invàlid, torna-ho a intentar.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Continua sense verificar la ubicació',
        enterSiteAccessCode: "Introdueix el codi d'accés al lloc",
        locationNotEnabledOrAvailable: 'Per què veig això?',
        notAvailable: {
          description: 'La ubicació GPS no està suportada en aquest dispositiu.',
          header: 'Ubicació no suportada',
        },
        notEnabled: {
          description: "Els serveis de ubicació no estan activats o no s'ha concedit permís.",
          header: 'Ubicació no activada',
        },
        notVerified: {
          description: 'El GPS indica que no ets al lloc.',
          header: 'Ubicació no verificada',
        },
        tryAgain: 'Torna-ho a intentar',
        unavailable: {
          description: 'No hem pogut verificar la teva ubicació GPS.',
          header: 'Ubicació no disponible',
        },
        unknown: {
          description: 'No podem determinar la teva ubicació.',
          header: 'Ubicació desconeguda',
        },
        verified: {
          description: 'El GPS indica que ets al lloc.',
          header: 'Ubicació verificada',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'No s’han trobat actius',
        emptyDescription: 'No hi ha actius associats amb aquesta ordre de treball.',
        warrantyParts: 'La garantia de les peces expira',
        serialNumber: 'Número de sèrie',
        none: '<cap>',
      },
      updates: {
        emptyTitle: 'No s’han trobat actualitzacions',
        emptyDescription: 'No hi ha actualitzacions per a aquesta ordre de treball.',
        unknownUser: 'Usuari desconegut',
        none: 'Cap',
        addComment: {
          buttonLabel: 'Afegir comentari',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Perills',
          no: 'No',
          yes: 'Sí',
        },
      },
    },
    attachmentsList: {
      attachments: 'Adjunts',
      documents: 'Documents',
      siteDocuments: 'Documents del lloc',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Perills',
        induction: 'Inducció',
        safeToProceed: 'Segur per continuar',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Data de venciment',
        activeSessions: 'Sessions actives',
        activeSessionsDescription:
          "Ja has iniciat sessió en les següents ordres de treball. Has de tancar la sessió d'aquestes ordres abans de poder iniciar sessió en una nova ordre de treball.",
        resumeSession: 'Reprèn',
        startTime: 'Iniciada a',
        unexpectedErrorTitle: 'Error inesperat',
        unexpectedErrorMessage:
          "S'ha produït un error inesperat mentre s'intentava crear les teves sessions. Si us plau, torna-ho a intentar més tard.",
        engineerNotFound: 'Enginyer no trobat',
        engineerNotFoundDescription:
          "L'enginyer amb qui estàs intentant iniciar sessió no es troba al sistema. Si us plau, contacta amb el teu administrador.",
      },
      verification: {
        code: {
          description:
            'Per iniciar sessió, si us plau, obtén el codi de 4 xifres del responsable del lloc o del contacte designat.',
        },
        geo: {
          continue: 'Continua',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              "Si us plau, obtingueu el codi d'accés del responsable del lloc o del contacte designat per completar la vostra visita.",
            checkOut: 'Tanca sessió',
            completeBeforeLeaving: 'Si us plau, completa el següent formulari abans de marxar.',
            continue: 'Continua',
            noResolutionSelected: 'Si us plau, selecciona una resolució abans de continuar.',
            quoteRequired: {
              hint: 'Visita completa, pressupost a seguir',
              label: 'Pressupost requerit',
            },
            returnVisitRequired: {
              hint: 'Tornarem a venir per completar-ho',
              label: 'Visita de retorn requerida',
            },
            serviceCompleted: {
              hint: 'No es requereix cap acció addicional',
              label: 'Servei completat',
            },
            uploadCheckout: 'Puja un fitxer, foto o vídeo',
            visitNotes: 'Notes de la visita',
            workOrderResolution: 'Resolució de l’ordre de treball',
            enterNotes: 'Introdueix qualsevol nota aquí...',
            errors: {
              timedOut:
                'Temps esgotat, s’han superat els 30 segons. Si us plau, torneu-ho a intentar.',
              closingSession: 'Error tancant la sessió',
            },
          },
          success: {
            description:
              'Gràcies per visitar {site}. | {site} encara té 1 ordre de treball oberta pendent. | {site} encara té {count} ordres de treball obertes pendents.',
            endVisit: 'Acaba la visita',
            header: 'Has tancat sessió correctament',
            viewWorkOrders: 'Inicia sessió en una altra ordre de treball',
          },
          verification: {
            code: {
              description:
                'Per tancar sessió, si us plau, obtén el codi de 4 xifres del responsable del lloc o del contacte designat.',
              continue: 'Continua',
            },
            geo: {
              checkOut: 'Tanca sessió',
              continue: 'Continua',
            },
          },
        },
        detail: {
          assets: 'Actius',
          call: 'Truca',
          checkOut: 'Tanca sessió',
          closed: 'Tancada',
          details: 'Detalls',
          dueBy: 'Data de venciment',
          manageEngineers: 'Gestiona enginyers',
          notAvailable: 'No disponible',
          pointOfContact: 'Persona de contacte',
          siteAccessTimes: "Horaris d'accés al lloc",
          siteAccessInstructions: "Instruccions d'accés",
          siteAddress: 'Adreça del lloc',
          siteNotes: 'Notes del lloc',
          siteTelephone: 'Telèfon del lloc',
          siteLocation: 'Ubicació del lloc',
          updates: 'Actualitzacions',
          more: 'Més',
          mismatchErrorTitle: 'Error d’ordre de treball',
          mismatchErrorMessage:
            'L’ordre de treball a la qual estàs intentant accedir no coincideix amb aquella en la qual estàs actualment registrat. Si us plau, verifica la teva ordre de treball i torna-ho a intentar.',
          siteDocuments: 'Documents del lloc',
          validFrom: 'Vàlid des de',
          validUntil: 'Vàlid fins a',
          documentName: 'Nom del document',
          documentType: 'Tipus de document',
          attachments: 'Fitxers de l’ordre de treball',
          download: 'Descarrega',
          workDetails: 'Detalls del treball',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Afegeix enginyer assistent',
            assistantEngineers: 'Enginyers assistents',
            description:
              'Per raons de seguretat, si us plau, especifica els noms de cada enginyer al lloc.',
            editMainEngineer: 'Edita l’enginyer principal',
            errors: {
              creatingEngineer: 'Error creant enginyer',
              creatingSession: 'Error creant sessió',
            },
            header: 'Enginyers al lloc',
            mainEngineer: 'Enginyer principal',
            newAssistantEngineer: 'Introdueix el seu nom complet',
            next: 'Següent',
            removeEngineer: 'Elimina enginyer',
            selectExistingAssistantEngineer: 'Comença a escriure el seu nom',
          },
          index: {
            description:
              'Per raons de seguretat, si us plau, especifica els noms de cada enginyer al lloc.',
            errorCreatingEngineer: 'Error creant enginyer, si us plau torna-ho a intentar.',
            header: 'Enginyers al lloc',
            hintMainEngineer: 'Introdueix el nom complet de l’enginyer principal',
            newMainEngineer: 'Nou enginyer principal',
            next: 'Següent',
            selectExistingMainEngineer: 'Selecciona un enginyer principal existent',
            yes: 'Sí',
            no: 'No',
            mainEngineerLabel: 'Ets l’enginyer principal?',
          },
        },
        index: {
          callUsOn: 'Truca’ns al {phoneNumber}',
          description: 'No trobes el que busques?',
          dueBy: 'Data de venciment',
          header: 'Selecciona ordre de treball',
          notAvailable: 'No disponible',
          searchWorkOrders: 'Cerca ordres de treball...',
        },
        manageEngineers: {
          manageEngineers: 'Gestiona enginyers',
          notWorking: 'Treballadors inactius',
          pause: 'Pausa',
          resume: 'Reprèn',
          workingNow: 'Treballadors actius',
          startTime: 'Hora d’inici',
          endTime: 'Hora de fi',
          duration: 'Durada',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Comentaris',
            feedbackDescription:
              'Si us plau, proporciona comentaris sobre l’ordre de treball per ajudar-nos a millorar els nostres serveis.',
            feedbackLabel: 'Comentaris',
            filesLabel: 'Adjunts',
            submissionLabel: 'Envia comentaris',
          },
          hazards: {
            back: 'Torna enrere',
            hazards: 'Perills',
            next: 'Següent',
            no: 'No',
            noTasksForHazard: 'No hi ha tasques a completar per aquest perill.',
            yes: 'Sí',
          },
          induction: {
            continue: 'Continua',
            induction: 'Inducció',
          },
          index: {
            checkIn: 'Inicia sessió',
            description:
              'Si us plau, completa l’avaluació de riscos següent per al treball seleccionat.',
            fail: 'Error en processar les comprovacions d’inici de l’ordre de treball.',
            haltMessage:
              'S’han detectat riscos potencials. Si us plau, atura el treball, revisa les directrius de seguretat i contacta amb el teu supervisor per a més instruccions.',
            header: 'Comprovacions abans d’iniciar el treball',
            endVisit: 'Acaba la visita',
            leaveFeedback: 'Deixa comentaris',
          },
          safeToProceed: {
            continue: 'Continua',
            safeToProceed: 'Segur per continuar',
          },
        },
      },
    },
    index: {
      title: 'Benvingut',
      description: 'Escaneja el codi QR a la teva ubicació per començar.',
    },
    login: {
      errorTitle: 'Error inesperat',
      errorMessage: "S'ha produït un error inesperat. Si us plau, torna a escanejar el codi QR.",
    },
    unauthenticated: {
      welcome: {
        title: 'Benvingut a {site}',
        description:
          'Abans que puguem mostrar-te qualsevol ordre de treball, hem de verificar les teves dades. Fes clic al botó a continuació per continuar.',
        next: 'Continua',
      },
      index: {
        errorTitle: 'Error inesperat',
        errorMessage: "S'ha produït un error inesperat. Si us plau, torna a escanejar el codi QR.",
      },
      contractor: {
        title: 'Per a qui treballes?',
        contractor: 'Contractista',
        contractorLabel: 'Comença a escriure el nom de la teva empresa',
        contractorHint: "Has d'introduir 3 caràcters o més per veure els resultats",
        defaultSelectPlaceholder: '--Si us plau selecciona--',
        next: 'Següent',
      },
      user: {
        title: 'Qui ets?',
        cancel: 'Cancel·la',
        createNewUserLabel: 'El meu nom no està a la llista',
        existingUserLabel: 'Comença a escriure el teu nom',
        existingUserHint: "Has d'introduir 3 caràcters o més per veure els resultats",
        newUserLabel: 'Introdueix el teu nom complet',
        next: 'Següent',
        user: 'Usuari',
      },
      verification: {
        methods: {
          add: {
            add: 'Afegeix mètode de verificació',
            defaultSelectPlaceholder: '--Si us plau selecciona--',
            emailLabel: 'Correu electrònic',
            existingMethodWarning:
              'Ja tens una sol·licitud pendent per aquest mètode de verificació a l’espera d’aprovació per part de l’administrador. Afegir-ne un nou substituirà l’anterior.',
            method: 'Mètode',
            methodLabel: 'Mètode',
            mobileCountryHint: 'Si us plau selecciona el codi del teu país',
            mobileCountryLabel: 'Codi de país mòbil',
            mobileHint: 'Si us plau, introdueix el teu número de mòbil',
            mobileLabel: 'Mòbil',
            title: 'Afegeix mètode de verificació',
          },
          confirm: {
            confirm: 'Confirma',
            description: 'Si us plau, confirma el teu mètode de verificació per continuar.',
            label: 'Introdueix el teu codi',
            resend: 'Reenviar',
            resendPrompt: 'No has rebut un codi?',
            title: 'Confirma el mètode de verificació',
          },
          confirmed: {
            description:
              'Rebràs una notificació un cop aquest mètode de verificació hagi estat aprovat pel teu administrador, i llavors podràs començar a utilitzar-lo per verificar la teva identitat.',
            forceApproval: 'Fins que no sigui aprovat, no podràs accedir a les ordres de treball.',
            nonForceApproval:
              'Mentrestant, podràs continuar accedint a les ordres de treball amb accés reduït.',
            nonForceApprovalButtonLabel: 'Continua amb accés reduït',
            title: 'A l’espera d’aprovació',
          },
          addNew: 'Afegeix un nou mètode de verificació',
          description:
            'Necessitem verificar la teva identitat per tal de donar-te accés complet a l’ordre de treball.',
          email: 'Correu electrònic',
          hint: 'Enviarem un enllaç al teu mètode de verificació seleccionat que et donarà accés complet a l’ordre de treball. Si necessites canviar algun mètode de verificació existent, si us plau contacta amb el teu administrador.',
          label: 'Selecciona un mètode de verificació',
          next: 'Següent',
          pendingHint: 'A l’espera d’aprovació per part del teu administrador',
          sms: 'SMS',
          title: 'Verificació',
        },
        optional: {
          hint: 'Verificar les teves dades d’usuari et donarà accés complet a l’ordre de treball',
          label: 'Vols verificar les teves dades d’usuari?',
          next: 'Següent',
          no: 'No',
          noHint:
            'No vull verificar les meves dades d’usuari i continuar amb accés reduït a l’ordre de treball',
          title: 'Verificació',
          yes: 'Sí',
          yesHint:
            'Vull verificar les meves dades d’usuari i obtenir accés complet a l’ordre de treball',
        },
        sent: {
          description:
            "S'ha enviat un enllaç d'inici de sessió a {identifier}. Si us plau, fes clic a l'enllaç per completar la teva sessió d'inici.",
          title: "Enllaç d'inici de sessió enviat",
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Ahir',
      today: 'Avui',
      days: {
        monday: 'Dilluns',
        tuesday: 'Dimarts',
        wednesday: 'Dimecres',
        thursday: 'Dijous',
        friday: 'Divendres',
        saturday: 'Dissabte',
        sunday: 'Diumenge',
      },
      months: {
        january: 'Gener',
        february: 'Febrer',
        march: 'Març',
        april: 'Abril',
        may: 'Maig',
        june: 'Juny',
        july: 'Juliol',
        august: 'Agost',
        september: 'Setembre',
        october: 'Octubre',
        november: 'Novembre',
        december: 'Desembre',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Alguna cosa ha anat malament',
      message: 'Si us plau, torna a escanejar el codi QR.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Usuari desconegut',
      },
      none: 'Cap',
      types: {
        stateTransition: 'Estat canviat',
        contractorAssigned: 'Contractista assignat',
        engineerAssigned: 'Enginyer assignat',
        serviceAssigned: 'Servei assignat',
        priorityChanged: 'Prioritat canviada',
        actionableDateChanged: 'Data d’acció canviada',
        dueDateChanged: 'Data de venciment canviada',
        etaDateChanged: 'Data d’arribada estimada canviada',
        spendLimitApproved: 'Límit de despesa aprovat',
        spendLimitCancelled: 'Sol·licitud de límit de despesa cancel·lada',
        spendLimitRejected: 'Sol·licitud de límit de despesa rebutjada',
        spendLimitRequested: 'Sol·licitud de límit de despesa',
        jobSheetUploaded: 'Full de treball pujat',
        slaAlertSent: 'S’ha superat el temps per atendre l’alerta SLA',
        issuedWorkPermit: 'Permís de treball emès',
        requestForServiceSent: 'Sol·licitud de servei enviada',
        comment: 'Comentari afegit',
        unknown: 'Esdeveniment desconegut',
      },
      labels: {
        actionableDate: 'Data d’acció',
        comment: 'Comentari',
        file: 'Fitxer',
        contractor: 'Contractista',
        dueDate: 'Data de venciment',
        etaDate: 'Data d’arribada estimada',
        engineer: 'Enginyer',
        priority: 'Prioritat',
        requestForService: 'Sol·licitud de servei',
        service: 'Servei',
        spendLimit: 'Límit de despesa',
        status: 'Estat',
        workPermit: 'Permís de treball',
      },
    },
  },
}
